/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum CompanyVboRepositoryRetentionType {
    Unknown = 0,
    ItemLevel = 1,
    SnapshotBased = 2,
}
